import React from 'react';
import { useGetProjectsQuery } from '../../../features/projects/projectsApi';
import Project from './Project';

const ProjectList = () => {

    const {data:projects, isLoading, isError} = useGetProjectsQuery();

    let content;

    if(isLoading){
        content = <div className='checkbox-container'>Loading...</div>
    }

    if(!isLoading && isError){
        content = <div className='checkbox-container'>something went wrong</div>
    }

    if(!isLoading && !isError && projects?.length === 0){
        content = <div className='checkbox-container'>No projects available</div>
    }

    if(!isLoading && !isError && projects?.length > 0){
        content = projects.map((project) => <Project key={project.id} name={project.projectName} color={project.colorClass}/>)
    }
    return (
        <div>
        <h3 className="text-xl font-bold">Projects</h3>
        <div className="mt-3 space-y-4">        
        {content}
        </div>
      </div>
    );
};

export default ProjectList;